/**
 * Basemap Configuration Constants
 *
 * All basemap configurations are now retrieved dynamically from the
 * dev_Basemap_extents feature service. No hardcoded basemaps.
 *
 * Type definitions are kept for TypeScript type safety.
 */

export interface BasemapConfig {
  name: string;
  styleId: string | null;
  webmapId: string | null;
  category: number;
  thumbnailUrl: string;
}

export interface BasemapsConfigType {
  [key: string]: BasemapConfig;
}

export const SESSION_STORAGE_KEY = 'swx-sentinel-basemap-session';
export const SESSION_DURATION_SECONDS = 43200; // 12 hours maximum
export const SESSION_STYLE_FAMILY = 'arcgis';
